  function createGtagEvents(elements = [], action = 'click', name = 'event_name') {
      if (!window.gtag) {
          console.error('GA4 events could not be established')
      }
      for (const el of elements) {
          el?.addEventListener(action, function(e) {
              if (name === 'header_nav_click') {
                  const textContent = el.innerText.trim();
                  gtag('event', name, {
                      'value': textContent
                  });
              } else {
                  gtag('event', name);
              }
          });
      }
  }
  
  const selectors = [
      /* Header nav clicks */
      {
          selector: 'store-header a',
          eventName: 'header_nav_click'
      },
      /* mini cart clicks */
      {
          selector: '#cart-icon',
          eventName: 'mini_cart_toggle'
      },
      /* cart page */
      {
          selector: 'button[name="checkout"]',
          eventName: 'begin_checkout'
      },
      /* Product page */
      {
          selector: 'details-disclosure:has(.product-description)',
          eventName: 'product_description_click'
      },
      {
          selector: 'media-gallery img',
          eventName: 'product_image_click'
      },
      {
          selector: 'details-disclosure:has(#pr-reviewdisplay)',
          eventName: 'reviews_click'
      }
  ];
  
  for (const s of selectors) {
      const el = document.querySelectorAll(s.selector);
      createGtagEvents(el, 'click', s.eventName);
  }
  
  document.querySelectorAll('form:has(input[type="email"])').forEach(emailInput => {
      emailInput.addEventListener('submit', e => {
          gtag('event', 'email_submit')
      })
  })
  
  window.onload = function() {
  
      var pathname = window.location.pathname;
  
      if (pathname.startsWith('/collections')) {
          gtag('event', 'view_collection_results');
          gtag('event', 'view_item_list');
          gtag('event', 'page_type',{
                  'page_type' : 'collection'
              }
          )
      } else if (pathname.startsWith('/search')) {
          gtag('event', 'view_search_results');
          gtag('event', 'view_item_list');
          gtag('event', 'page_type',{
                  'page_type' : 'search'
              }
          )
      }
      else{
          gtag('event', 'page_type', {
              'page_type': pathname === '/' ? 'homepage' : pathname.substring(1)
          });
      }
  };
  
  document.querySelector('.main-nav').addEventListener('click', items => {
      gtag('event', 'view_item_list')
  })
  
  var scrollThresholds = [25, 50, 75, 90]; 
  let currScroll;
  window.addEventListener('scrollend', function() {
      var scrollPercentage = Math.round((window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100);
      scrollThresholds.forEach(function(threshold) {
      if (scrollPercentage >= threshold) {
              currScroll = threshold;
          }
      });
  
          gtag('event', 'scroll', {
          'percent_scrolled': currScroll
          });
  });
